<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <h4>{{issue.user.firstName}} para terminar tu reclamación revisala antes de enviar.</h4>
    </div>
    <div class="md-layout-item md-layout md-size-100 md-alignment-center-center">
      <div class="md-layout-item md-size-66 divTable">
        <div class="divRow">
          <div class="divCell">
            <h5 class="title">Datos Personales</h5>
          </div>
        </div>
        <div class="divRow">
          <div class="divCell">Correo electrónico:</div>
          <div class="divCell">{{issue.user.email}}</div>
        </div>
        <div class="divRow">
          <div class="divCell">Teléfono:</div>
          <div class="divCell">{{issue.user.phone}}</div>
        </div>
        <div class="divRow">
          <div class="divCell">
            <h5 class="title">Producto</h5>
          </div>
        </div>

        <div class="divRow" v-if="!issue.product.selected">
          <div class="divCell">Lote:</div>
          <div class="divCell">{{issue.product.lote}}</div>
        </div>
        <div class="divRow" v-if="issue.product.selected">
          <div class="divCell">Nombre Producto:</div>
          <div class="divCell">{{issue.product.type.name}}</div>
        </div>
        <div class="divRow" v-if="issue.product.provincia != null">
          <div class="divCell">Provincia:</div>
          <div class="divCell">{{issue.product.provincia.name}}</div>
        </div>
        <div class="divRow" v-if="issue.product.municipio != null">
          <div class="divCell">Población:</div>
          <div class="divCell">{{issue.product.municipio.name}}</div>
        </div>
        <div class="divRow" v-if="issue.product.comercio != null">
          <div class="divCell">Comercio:</div>
          <div class="divCell">{{issue.product.comercio.name}}</div>
        </div>
        <div class="divRow">
          <div class="divCell">
            <h5 class="title">Problema</h5>
          </div>
        </div>
        <div class="divRow">
          <div class="divCell" v-if="issue.product.problemDesc">Tipo:</div>
          <div class="divCell">{{issue.product.problemDesc}}</div>
        </div>
        <div class="divRow">
          <div class="divCell" v-if="issue.product.observaciones">Observaciones:</div>
          <div class="divCell">{{issue.product.observaciones}}</div>
        </div>
      </div>
    </div>

    <div class="md-layout-item md-size-100">
      <p>En breve nos pondremos en contacto contigo.</p>
      <label>En Florette queremos estar cerca de tí, danos tu dirección postal para poder hacer un seguimiento cercano de tu reclamación.</label>
      <md-field>
        <md-icon>edit_location</md-icon>
        <label>Dirección</label>
        <md-input v-model="issue.user.address" data-vv-name="address" type="text" name="address"></md-input>
      </md-field>
      <h5>Muchas gracias por tu ayuda.</h5>
    </div>
  </div>
</template>


<script>
export default {
  name: "StepSummary",
  mixins: [],
  components: {},
  props: {
    issue: {
      type: Object,
      required: false,
      default: () => {
        null;
      }
    }
  },
  data() {
    return {};
  },
  model: {
    event: "next"
  },
  methods: {
    setDone() {
      this.$emit("next", null);
    },
    validate() {
      return this.$validator.validateAll().then(res => {
        this.$emit("on-validated", res);
        return res;
      });
    }
  }
};
</script>


<style scoped>
.title {
  font-weight: bold;
  margin-top: 20px;
}
.divTable {
  display: table;
  /* border-collapse:separate;*/
  text-align: left;
}

.divRow {
  display: table-row;
  width: auto;
}

.divCell {
  float: left; /*fix for  buggy browsers*/
  display: table-column;
  width: 200px;
}
</style>
